<template>
    <CardContent :title="title">
        <template v-slot:breadcumb>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link :to="'/'">
                        <i class="feather icon-home"></i>
                    </router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/smartlog">SmartLog</router-link>
                </li>
                <li class="breadcrumb-item active">{{ title }}</li>
            </ol>
        </template>

        <template v-slot:content>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-content">
                            <div class="card-body card-dashboard">
                                <ValidationObserver ref="observer" v-slot="{ invalid }">
                                    <div class="row">
                                        <ValidationProvider class="col-md-6" name="nama material" rules="required"
                                            v-slot="{ errors }">
                                            <div class="form-group">
                                                <label for="">Nama Material <span class="text-danger">*</span></label>
                                                <input type="text" v-model="form.name" class="form-control"
                                                    :class="{ 'is-invalid': errors[0] }">
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </div>
                                        </ValidationProvider>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Id Material <span class="text-danger">*</span></label>
                                                <input type="text" v-model="form.code" id="" class="form-control"
                                                    :class="{ 'is-invalid': errors?.code }">
                                                <small class="text-danger">{{ errors?.code?.[0] }}</small>
                                            </div>
                                        </div>

                                        <!-- <ValidationProvider class="col-md-6" name="id material" rules="required"
                                            v-slot="{ errors }">
                                            <div class="form-group">
                                                <label for="">Id Material <span class="text-danger">*</span></label>
                                                <input type="text" v-model="form.code" id="" class="form-control"
                                                    :class="{ 'is-invalid': errors[0] }">
                                                <small class="text-danger" v-if="errors?.code">{{ errors?.code?.[0] }}</small>
                                            </div>
                                        </ValidationProvider> -->

                                        <div class="col-12">
                                            <div class="form-group">
                                                <label>Foto</label>
                                                <div class="foto-container">
                                                    <!-- Upload Box -->
                                                    <div class="upload-box" @click="openFilePicker">
                                                        <i class="fa fa-image"></i>
                                                    </div>
                                                    <input ref="fileInput" type="file" class="d-none"
                                                        @change="handleFoto" multiple accept=".jpg,.jpeg" />

                                                    <!-- Preview -->
                                                    <div v-for="(gallery, index) in input_galleries" :key="index"
                                                        class="preview-box">
                                                        <div class="preview-box">
                                                            <img v-if="gallery.file" :src="gallery.preview"
                                                                class="preview-img" data-toggle="tooltip"
                                                                data-placement="top" />
                                                            <img v-else :src="gallery.image" class="preview-img" />
                                                            <!-- Remove -->
                                                            <button class="btn-remove"
                                                                @click="removeFoto(index, gallery)">×</button>
                                                            <!-- Set as Main -->
                                                            <div class="set-main" @click="setAsMain(index)">
                                                                {{ gallery.is_main ? 'Cover' : 'Set as main' }}
                                                            </div>
                                                        </div>
                                                        <!-- Error Message -->
                                                        <div v-if="errors[`material_galleries.${index}.image`]"
                                                            class="text-primary d-block mt-1 p-1 error-text">
                                                            Error!
                                                            {{
                                                                errors[`material_galleries.${index}.image`][0]
                                                                    .replace(`The material_galleries.${index}.image`, `File `)
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <ValidationProvider class="col-md-6" name="kategori" rules="required"
                                            v-slot="{ errors }">
                                            <div class="form-group">
                                                <label for="">Kategori <span class="text-danger">*</span></label>
                                                <multiselect v-model="selectedCategory" :options="categories"
                                                    placeholder="Select" select-label="✔" deselect-label="✖"
                                                    label="name" track-by="id" :close-on-select="true"
                                                    @input="handleChangeCategory" />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </div>
                                        </ValidationProvider>

                                        <ValidationProvider class="col-md-6" name="sub kategori" rules="required"
                                            v-slot="{ errors }">
                                            <div class="form-group">
                                                <label for="">Sub Kategori <span class="text-danger">*</span></label>
                                                <multiselect class="is-invalid" v-model="selectedSubCategories"
                                                    :options="sub_categories" placeholder="Select" select-label="✔"
                                                    deselect-label="✖" label="name" track-by="id"
                                                    :close-on-select="true" />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </div>
                                        </ValidationProvider>

                                        <ValidationProvider class="col-md-6" name="kondisi material" rules="required"
                                            v-slot="{ errors }">
                                            <div class="form-group">
                                                <label for="" class="mb-2">Kondisi Material <span
                                                        class="text-danger">*</span></label>
                                                <div class="custom-radio-group d-flex">
                                                    <label class="custom-radio">
                                                        <input type="radio" value="Baru" v-model="form.type" />
                                                        <span class="radio-circle"></span>
                                                        Baru
                                                    </label>

                                                    <label class="custom-radio">
                                                        <input type="radio" value="Bekas" v-model="form.type" />
                                                        <span class="radio-circle"></span>
                                                        Bekas
                                                    </label>
                                                </div>
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </div>
                                        </ValidationProvider>

                                        <ValidationProvider class="col-md-6" name="keadaan"
                                            :rules="selectedCondition.length == 0 ? 'required' : ''"
                                            v-slot="{ errors }">
                                            <div class="form-group">
                                                <label for="" class="mb-2">Keadaan <span
                                                        class="text-danger">*</span></label>
                                                <multiselect v-model="selectedCondition" :options="material_conditions"
                                                    :multiple="true" placeholder="Select" selected-label="✔"
                                                    select-label="✔" deselect-label="✖" label="name" track-by="id"
                                                    :close-on-select="false"
                                                    @input="form.condition_ids = selectedCondition.map(item => item.id)"
                                                    @open="getMaterialConditions()"
                                                    @search-change="getMaterialConditions" />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </div>
                                        </ValidationProvider>

                                        <ValidationProvider class="col-md-6" name="kategori material" rules="required"
                                            v-slot="{ errors }">
                                            <div class="form-group">
                                                <label for="formSelectKategoriMaterial">
                                                    Kategori Material <span class="text-danger">*</span>
                                                </label>
                                                <multiselect v-model="form.material_category"
                                                    :options="['PDP', 'Non PDP', 'ATTB']" placeholder="Select"
                                                    select-label="✔" deselect-label="✖" :close-on-select="true" />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </div>
                                        </ValidationProvider>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Spesifikasi</label>
                                                <input type="text" v-model="form.specification" class="form-control">
                                                <!-- <quill-editor v-model="form.specification" :options="editorOption" /> -->
                                                <small v-if="errors.specification" class="text-danger">
                                                    <span v-for="(error, key) in errors.specification" :key="key">
                                                        {{ error }}
                                                    </span>
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="" class="mb-2">Kontrak Asal Material</label>
                                                <div class="custom-radio-group d-flex">
                                                    <label class="custom-radio">
                                                        <input type="radio" value="select" v-model="deafult_kontrak" />
                                                        <span class="radio-circle"></span>
                                                        Pilih Project
                                                    </label>

                                                    <label class="custom-radio">
                                                        <input type="radio" value="text" v-model="deafult_kontrak" />
                                                        <span class="radio-circle"></span>
                                                        Manual
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-8" v-if="deafult_kontrak == 'select'">
                                            <div class="form-group">
                                                <label for="formSelectKategoriMaterial">Select Project</label>
                                                <multiselect v-model="selectedProject" :options="contracts"
                                                    :custom-label="customLabelKontrak" placeholder="Select"
                                                    label="judul_kontrak" track-by="id" :loading="loadKontrak"
                                                    :searchable="true" select-label="✔" deselect-label="✖"
                                                    @open="getKontrak()" @search-change="getKontrak" />
                                            </div>

                                        </div>

                                        <div class="col-md-6" v-if="deafult_kontrak == 'text'">
                                            <div class="form-group">
                                                <label for="">Nomor Kontrak</label>
                                                <input type="text" v-model="form.contract_number" class="form-control">
                                                <small v-if="errors.contract_number" class="text-danger">
                                                    <span v-for="(error, key) in errors.contract_number" :key="key">
                                                        {{ error }}
                                                    </span>
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-md-6" v-if="deafult_kontrak == 'text'">
                                            <div class="form-group">
                                                <label for="">Judul Kontrak</label>
                                                <input type="text" v-model="form.contract_title" class="form-control">
                                                <small v-if="errors.contract_title" class="text-danger">
                                                    <span v-for="(error, key) in errors.contract_title" :key="key">
                                                        {{ error }}
                                                    </span>
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Attachment</label>
                                                <div>
                                                    <div class="border border-info border-dashed text-primary text-center py-1 w-100"
                                                        style="cursor: pointer;" @click="openFileInput">
                                                        <i class="fa fa-cloud-upload fa-lg"></i> Drop files here to
                                                        upload
                                                    </div>
                                                    <input type="file" ref="fileAttachment" multiple class="hidden"
                                                        @change="handleFiles" />

                                                    <div v-for="(item, index) in input_attachments" :key="index"
                                                        class=" py-1 px-2 mt-1 rounded"
                                                        style="background-color: rgb(218, 241, 250);">
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <div v-if="item.file"
                                                                class="d-flex align-items-center text-truncate"
                                                                style="color: rgb(25, 125, 167);">
                                                                <i class="fa fa-file fa-lg mr-2"></i>
                                                                <a :href="item.previewUrl" target="_blank"
                                                                    class="text-decoration-underline text-truncate"
                                                                    style="color: rgb(25, 125, 167);">
                                                                    {{ item.file?.name }}
                                                                </a>
                                                            </div>
                                                            <div v-else class="d-flex align-items-center text-truncate"
                                                                style="color: rgb(25, 125, 167);">
                                                                <i class="fa fa-file fa-lg mr-2"></i>
                                                                <a :href="item.previewUrl" target="_blank"
                                                                    class="text-decoration-underline text-truncate"
                                                                    style="color: rgb(25, 125, 167);">
                                                                    {{ item?.name }}
                                                                </a>
                                                            </div>
                                                            <span
                                                                class="badge badge-danger rounded-circle d-flex align-items-center justify-content-center"
                                                                @click="removeAttachment(index, item)"
                                                                style="cursor: pointer;">
                                                                <i class="fa fa-close"></i>
                                                            </span>
                                                        </div>
                                                        <div v-if="errors[`attachments.${index}`]" class="text-danger">
                                                            Error!
                                                            {{ errors[`attachments.${index}`][0]
                                                                .replace(`The attachments.${index}`, `File `)
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6"></div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Merek</label>
                                                <multiselect v-model="selectedBrand" :options="brands"
                                                    placeholder="Select" selected-label="✔" select-label="✔"
                                                    deselect-label="✖" label="name" track-by="id"
                                                    :close-on-select="true" @input="form.brand_id = selectedBrand?.id"
                                                    @open="getBrand()" @search-change="getBrand" />

                                                <small v-if="errors.brand" class="text-danger">
                                                    <span v-for="(error, key) in errors.brand" :key="key">
                                                        {{ error }}
                                                    </span>
                                                </small>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Pabrikan</label>
                                                <multiselect v-model="selectedFactory" :options="factories"
                                                    placeholder="Select" selected-label="✔" select-label="✔"
                                                    deselect-label="✖" label="name" track-by="id"
                                                    :close-on-select="true"
                                                    @input="form.factory_id = selectedFactory?.id" @open="getFactory()"
                                                    @search-change="getFactory">
                                                </multiselect>
                                                <small v-if="errors.factory" class="text-danger">
                                                    <span v-for="(error, key) in errors.factory" :key="key">
                                                        {{ error }}
                                                    </span>
                                                </small>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Tahun Pembuatan</label>
                                                <date-picker v-model="form.year" type="year" format="YYYY"
                                                    value-type="YYYY" placeholder="Pilih tahun" style="width: 100%;" />
                                                <small v-if="errors.year" class="text-danger">
                                                    <span v-for="(error, key) in errors.year" :key="key">
                                                        {{ error }}
                                                    </span>
                                                </small>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Negara Produksi</label>
                                                <multiselect v-model="selectedCountry" :options="countries"
                                                    placeholder="Select" selected-label="✔" select-label="✔"
                                                    deselect-label="✖" label="name" track-by="id"
                                                    :close-on-select="true"
                                                    @input="form.country_id = selectedCountry?.id" @open="getCountry()"
                                                    @search-change="getCountry">
                                                </multiselect>
                                                <small v-if="errors.country" class="text-danger">
                                                    <span v-for="(error, key) in errors.country" :key="key">
                                                        {{ error }}
                                                    </span>
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Lokasi</label>
                                                <multiselect v-model="selectedUnits" :options="units"
                                                    placeholder="Select" select-label="✔" deselect-label="✖"
                                                    label="name" track-by="id" :close-on-select="true" />
                                                <small v-if="errors.unit_id" class="text-danger">
                                                    <span v-for="(error, key) in errors.unit_id" :key="key">
                                                        {{ error }}
                                                    </span>
                                                </small>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Gudang</label>
                                                <multiselect v-model="selectedWarehouses" :options="gudangs"
                                                    placeholder="Select" select-label="✔" deselect-label="✖"
                                                    label="name" track-by="id" :close-on-select="true" />
                                                <small v-if="errors.warehouse_id" class="text-danger">
                                                    <span v-for="(error, key) in errors.warehouse_id" :key="key">
                                                        {{ error }}
                                                    </span>
                                                </small>
                                            </div>
                                        </div>

                                        <!-- Modal tambah gudang baru -->
                                        <ModalB4 title="Other" id="modalOtherInput" size="sm">
                                            <input type="text" class="form-control" v-model="form.new_warehouse_name"
                                                placeholder="Masukkan nama gudang" ref="otherInput"
                                                @keyup.enter="addOtherWarehouse" autofocus="true" />
                                            <template #footer>
                                                <button class="btn btn-primary" @click="addOtherWarehouse"
                                                    data-dismiss="modal">Select</button>
                                                <button class="btn btn-secondary" @click="showOtherInput = false"
                                                    data-dismiss="modal">Batal</button>
                                            </template>
                                        </ModalB4>

                                        <div class="col-md-6">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="">Stock</label>
                                                        <input type="text" @input="filterNumber" v-model="form.stock"
                                                            class="form-control">
                                                        <small v-if="errors.stock" class="text-danger">
                                                            <span v-for="(error, key) in errors.stock" :key="key">
                                                                {{ error }}
                                                            </span>
                                                        </small>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="">Satuan</label>
                                                        <multiselect v-model="selectedSatuan" :options="satuans"
                                                            placeholder="Select" select-label="✔" deselect-label="✖"
                                                            label="name" track-by="id" :close-on-select="true"
                                                            @input="form.material_unit_id = selectedSatuan?.id"
                                                            @open="getSatuan()" @search-change="getSatuan()" />
                                                        <small v-if="errors.material_unit_id" class="text-danger">
                                                            <span v-for="(error, key) in errors.material_unit_id"
                                                                :key="key">
                                                                {{ error }}
                                                            </span>
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Contact Person</label>
                                                <multiselect v-model="selectedKontak" :options="kontaks"
                                                    placeholder="Select" select-label="✔" deselect-label="✖"
                                                    :custom-label="customLabelKontak" track-by="id"
                                                    :close-on-select="true"
                                                    @input="form.contact_person_id = selectedKontak?.id"
                                                    @open="getKontak()" @search-change="getKontak()" />
                                                <small v-if="errors.contact_person_id" class="text-danger">
                                                    <span v-for="(error, key) in errors.contact_person_id" :key="key">
                                                        {{ error }}
                                                    </span>
                                                </small>
                                            </div>
                                        </div>

                                        <!-- Modal tambah kontak baru -->
                                        <ModalB4 title="Other" id="modalOtherContactInput" size="sm">
                                            <input type="text" class="form-control"
                                                v-model="form.new_contact_person_name"
                                                placeholder="Masukkan nama kontak" ref="otherInputContact"
                                                @keyup.enter="addOtherKontak" autofocus="true" />
                                            <input type="text" class="form-control mt-2" ref="otherInputPhone"
                                                v-model="form.new_contact_person_phone_number"
                                                placeholder="Masukkan nomor kontak" @keyup.enter="addOtherKontak" />
                                            <template #footer>
                                                <button class="btn btn-primary" @click="addOtherKontak"
                                                    data-dismiss="modal">Select</button>
                                                <button class="btn btn-secondary" @click="showOtherInput = false"
                                                    data-dismiss="modal">Batal</button>
                                            </template>
                                        </ModalB4>
                                        <!-- Modal tambah kontak person baru -->

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="" class="mb-2">Status</label>
                                                <div class="custom-radio-group d-flex">
                                                    <label class="custom-radio" v-if="form.stock > 0">
                                                        <input type="radio" value="Tersedia" v-model="form.status" />
                                                        <span class="radio-circle"></span>
                                                        Tersedia
                                                    </label>

                                                    <label class="custom-radio" v-if="form.stock == 0">
                                                        <input type="radio" value="Dipinjam" v-model="form.status" />
                                                        <span class="radio-circle"></span>
                                                        Dipinjam
                                                    </label>

                                                    <label class="custom-radio" v-if="form.stock == 0">
                                                        <input type="radio" value="Tidak Tersedia"
                                                            v-model="form.status" />
                                                        <span class="radio-circle"></span>
                                                        Tidak Tersedia
                                                    </label>
                                                </div>
                                                <small v-if="errors.status" class="text-danger">
                                                    <span v-for="(error, key) in errors.status" :key="key">
                                                        {{ error }}
                                                    </span>
                                                </small>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="d-flex flex-wrap justify-content-end align-items-center">
                                        <button @click="cancel()" type="button"
                                            class="btn btn-outline-primary mr-1 btn-lg">Batal</button>
                                        <button @click="save()" :disabled="invalid" type="button"
                                            class="btn btn-primary btn-lg">
                                            {{ saving ? "Menyimpan" : "Simpan" }}
                                        </button>
                                    </div>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </CardContent>
</template>

<script>
import CardContent from '@/components/CardContent.vue'
import ModalB4 from '@/components/ModalB4.vue'
import { EventBus } from '@/plugins/eventBus.js'
import { getBrand, getCountry, getFactory, getMaterialConditions, getKontrak, getKontak, getSatuan } from '../../../api/master'

export default {
    components: { CardContent, ModalB4 },
    data() {
        return {
            editorOption: {
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        [{ indent: "-1" }, { indent: "+1" }],
                    ],
                },
            },
            saving: false,
            errors: [],
            input_galleries: [],
            deleted_galleries: [],
            deleted_attachments: [],
            input_attachments: [],
            deafult_kontrak: "",
            selectedProject: "",
            selectedUnits: "",
            selectedCategory: "",
            selectedSubCategories: "",
            selectedWarehouses: "",
            selectedCondition: [],
            selectedBrand: "",
            selectedFactory: "",
            selectedCountry: "",
            selectedKontak: "",
            selectedSatuan: "",
            // master data
            gudangs: [],
            sub_categories: [],
            categories: [],
            contracts: [],
            units: [],
            brands: [],
            kontaks: [],
            satuans: [],
            factories: [],
            countries: [],
            material_conditions: [],
            title: this.$route.name == "CreateMaterial" ? "Tambah Logistik" : "Edit Material",
            model: [],
            role_id: localStorage.getItem('role_id'),
            form: {
                name: "",
                code: "",
                category_id: "",
                sub_category_id: "",
                material_category: "PDP",
                type: "Baru",
                condition_ids: [],
                status: "Tersedia",
                specification: "",
                material_galleries: [],
                attachments: [],
                unit_id: "",
                warehouse_id: "",
                stock: 0,
                cp_name: "",
                cp_phone: "",
                contract_id: "",
                contract_number: "",
                contract_title: "",
                year: "",
                brand_id: "",
                factory_id: "",
                country_id: "",
                is_bookmark: "",
                new_warehouse_name: "",
                contact_person_id: "",
                material_unit_id: "",
                new_contact_person_name: "",
                new_contact_person_phone_number: "",
            },
            loadKontrak: false,
            isDirty: true,
        }
    },
    mounted() {
        this.getUnit()
        this.getGudang()
        this.getCategory()
        this.getMaterialConditions()
        this.getFactory()
        this.getBrand()
        this.getCountry()
        this.getSatuan()
        this.getKontak()

        if (this.$route.name == "EditMaterial") {
            this.getMaterial()
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.isDirty) {
            EventBus.$emit('block-navigation', true)
            this.$swal.fire({
                text: 'Apakah Anda ingin menyimpan data?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya, tetap di halaman.',
                cancelButtonText: 'Tidak, tinggalkan halaman.',
            }).then((result) => {
                EventBus.$emit('block-navigation', false)

                if (result.isConfirmed) {
                    next(false);
                } else {
                    next();
                }
            });
        } else {
            next()
        }
    },
    methods: {
        filterNumber(e) {
            const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
            this.form.stock = onlyNumbers;
        },
        async getBrand(query) {
            this.brands = await getBrand(query)
        },
        async getCountry(query) {
            this.countries = await getCountry(query)
        },
        async getFactory(query) {
            this.factories = await getFactory(query)
        },
        async getMaterialConditions(query) {
            this.material_conditions = await getMaterialConditions(query)
        },
        async getKontrak(query) {
            this.contracts = await getKontrak(query)
        },
        async getKontak(query) {
            const res = await getKontak(query)
            this.kontaks = [...res, { id: 'other', name: 'Other', isOther: true }]
        },
        async getSatuan(query) {
            this.satuans = await getSatuan(query)
        },
        getMaterial() {
            let _ = this
            const id = _.$route.params.material_id
            _.axios.get('/materials/' + id)
                .then(resp => {
                    const material = resp.data.data
                    console.log("material", material.storage)
                    this.form.can_manage = material.can_manage
                    this.form.name = material.name
                    this.form.code = material.code
                    this.form.category_id = material.category_id
                    this.form.sub_category_id = material.sub_category_id
                    this.form.material_category = material.material_category
                    this.form.type = material.type
                    this.form.status = material.status
                    this.form.specification = material.specification
                    this.form.unit_id = material.unit_id
                    this.form.warehouse_id = material.warehouse_id
                    this.form.stock = material.storage.stock
                    this.form.cp_name = material.storage.cp_name
                    this.form.cp_phone = material.storage.cp_phone
                    this.form.contract_id = material.contract.contract_id ?? ""
                    this.form.contract_number = material.contract.contract_number
                    this.form.contract_title = material.contract.contract_title
                    this.form.year = material.manufacturer.year
                    this.form.brand_id = material.manufacturer.brand?.id
                    this.form.factory_id = material.manufacturer.factory?.id
                    this.form.country_id = material.manufacturer.country?.id
                    this.form.is_bookmark = material.is_bookmark
                    this.input_galleries = material.galleries
                    this.input_attachments = material.contract.attachments
                    this.selectedCategory = { 'id': material.category.id, 'name': material.category.name }
                    this.selectedSubCategories = { 'id': material.sub_category.id, 'name': material.sub_category.name }
                    if (material.storage.material_unit) {
                        this.selectedSatuan = { 'id': material.storage.material_unit.id, 'name': material.storage.material_unit.name }
                        this.material_unit_id = material.storage.material_unit.id
                    }
                    if (material.storage.contact_person) {
                        this.selectedKontak = { 'id': material.storage.contact_person.id, 'name': material.storage.contact_person.name, 'phone_number': material.storage.contact_person.phone_number }
                    }
                    if (material.conditions) {
                        material.conditions.forEach(item => {
                            this.selectedCondition.push({ id: item.id, name: item.name })
                            this.form.condition_ids.push(item.id)
                        })
                    }
                    if (material.manufacturer?.brand) {
                        this.selectedBrand = { 'id': material.manufacturer.brand.id, 'name': material.manufacturer.brand.name }
                    }
                    if (material.manufacturer?.factory) {
                        this.selectedFactory = { 'id': material.manufacturer.factory.id, 'name': material.manufacturer.factory.name }
                    }
                    if (material.manufacturer?.country) {
                        this.selectedCountry = { 'id': material.manufacturer.country.id, 'name': material.manufacturer.country.name }
                    }
                    if (material.storage.warehouse_id) {
                        this.selectedWarehouses = { 'id': material.storage.warehouse.id, 'name': material.storage.warehouse.name }
                    }
                    if (material.storage.unit_id) {
                        this.selectedUnits = { 'id': material.storage.unit.id, 'name': material.storage.unit.name }
                    }

                    if (this.form.contract_id) {
                        this.deafult_kontrak = 'select'
                        this.selectedProject = {
                            'id': material.contract.contract_id,
                            'no_kontrak': material.contract.contract_number,
                            'judul_kontrak': material.contract.contract_title,
                        }
                    } else {
                        this.deafult_kontrak = 'text'
                    }
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        openFilePicker() {
            this.$refs.fileInput.click();
        },
        handleFoto(event) {
            const files = Array.from(event.target.files);
            const maxSize = 2 * 1024 * 1024; // 2MB

            files.forEach((file) => {
                // validasi
                if (file.size > maxSize) {
                    alert(`Gambar "${file.name}" melebihi batas 2MB`);
                    return;
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.input_galleries.push({
                        file,
                        preview: e.target.result,
                        is_main: this.input_galleries.length === 0 ? 1 : 0
                    });
                };
                reader.readAsDataURL(file);
            });
            event.target.value = '';
        },
        removeFoto(index, item) {
            // Jika item memiliki ID, berarti gambar lama
            if (item.id) {
                console.log("menghapus gallery id", item.id)
                this.deleted_galleries.push(item.id);
            }
            const removed = this.input_galleries.splice(index, 1);
            if (removed[0]?.is_main && this.input_galleries.length > 0) {
                this.input_galleries[0].is_main = 1;
            }
        },
        setAsMain(index) {
            this.input_galleries.forEach((a, i) => {
                a.is_main = i === index ? 1 : 0;
            });
        },
        openFileInput() {
            this.$refs.fileAttachment.click();
        },
        handleFiles(event) {
            const files = event.target.files;
            const maxSize = 40 * 1024 * 1024; // 5MB
            files.forEach(file => {
                if (file.size > maxSize) {
                    alert(`File "${file.name}" melebihi batas 40 MB`);
                    return;
                }
                this.input_attachments.push({
                    file,
                    previewUrl: URL.createObjectURL(file)
                });
            });
        },
        removeAttachment(index, item) {
            if (item.name) {
                this.deleted_attachments.push(item.name);
            }
            this.input_attachments.splice(index, 1);
        },
        getGudang() {
            let _ = this
            _.axios.get('/warehouses?unit_ids=')
                .then(resp => {
                    // _.gudangs = resp.data.data
                    _.gudangs = [...resp.data.data, { id: 'other', name: 'Other', isOther: true }]
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        addOtherWarehouse() {
            if (this.form.new_warehouse_name.trim()) {
                const newWarehouse = {
                    id: `new_${Date.now()}`,
                    name: this.form.new_warehouse_name,
                    isNewTag: true
                }
                this.gudangs.push(newWarehouse)
                this.selectedWarehouses = newWarehouse
                this.showOtherInput = false
            }
            this.form.warehouse_id = null
            window.$('#modalOtherInput').modal('hide')
        },
        addOtherKontak() {
            if (this.form.new_contact_person_name.trim()) {
                const newKontak = {
                    id: `new_${Date.now()}`,
                    name: this.form.new_contact_person_name,
                    phone_number: this.form.new_contact_person_phone_number,
                    isNewTag: true
                }
                this.kontaks.push(newKontak)
                console.log("new kontak", this.kontaks)
                this.selectedKontak = newKontak
                this.showOtherInput = false
            }
            this.form.contact_person_id = null
            window.$('#modalOtherContactInput').modal('hide')
        },
        getUnit() {
            let _ = this
            _.axios.get('/unit', {
                params: {
                    only_allowed_units: 1,
                }
            })
                .then(resp => {
                    _.units = resp.data.data.data
                })
                .catch(err => {
                    console.log("gagal", err.response)
                })
        },
        getSubCategory(category) {
            let _ = this
            _.axios.get('/categories', {
                params: {
                    parent_id: category
                }
            })
                .then(resp => {
                    _.sub_categories = resp.data.data
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        getCategory() {
            let _ = this
            _.axios.get('/categories?parent_id=0')
                .then(resp => {
                    _.categories = resp.data.data
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        handleChangeCategory() {
            this.sub_categories = []
            this.form.sub_category_id = ''
            this.selectedSubCategories = ''
            this.form.category_id = this.selectedCategory.id
            this.getSubCategory(this.selectedCategory.id)
        },
        customLabelKontrak({ no_kontrak, judul_kontrak }) {
            return `${no_kontrak} — ${judul_kontrak}`
        },
        customLabelKontak({ name, phone_number }) {
            if (!phone_number) {
                return name;
            }
            return `${name} - ${phone_number ?? ''}`;
        },
        save() {
            let _ = this
            _.saving = true
            _.isDirty = false
            // mencegah nilai undefined masuk ke payload
            const payload = Object.fromEntries(
                Object.entries(_.form).filter(([, value]) => value !== undefined)
            )

            const formData = new FormData()
            for (const key in payload) {
                if (payload[key] !== undefined && payload[key] !== null) {
                    if (key === 'material_galleries' || key === 'attachments') {
                        // Skip these fields, they will be handled separately
                        continue;
                    } else if (Array.isArray(payload[key])) {
                        // Jika field adalah array, kita append manual sebagai array
                        payload[key].forEach((item, index) => {
                            formData.append(`${key}[${index}]`, item);
                        });
                    } else {
                        // Append field biasa
                        formData.append(key, payload[key]);
                    }
                }
            }

            // mode edit
            if (_.$route.name == "EditMaterial") {
                formData.append('_method', 'PUT')
                if (_.deleted_attachments.length > 0) {
                    _.deleted_attachments.forEach(item => {
                        formData.append('deleted_attachments[]', item)
                    });
                }
                if (_.deleted_galleries.length > 0) {
                    _.deleted_galleries.forEach(item => {
                        formData.append('deleted_material_gallery_ids[]', item)
                    });
                }
            }

            // Khusus material_galleries, kita perlakukan sebagai array of object
            _.input_galleries.forEach((item, index) => {
                if (item.file) {
                    formData.append(`material_galleries[${index}][image]`, item.file);
                    formData.append(`material_galleries[${index}][is_main]`, item.is_main);
                }
            });
            // Khusus attachments, kita perlakukan sebagai array of object
            _.input_attachments.forEach((item, index) => {
                if (item.file) {
                    formData.append(`attachments[${index}]`, item.file);
                }
            });

            const url = _.$route.name == "CreateMaterial" ? "/materials" : "/materials/" + _.$route.params.material_id

            // swal konfirmasi
            this.$swal.fire({
                text: "Apakah Anda yakin, data material yang diinput sudah sesuai?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#44A8BD',
                cancelButtonColor: '#D95E6A',
                confirmButtonText: 'Ya',
                cancelButtonText: 'Tidak'
            }).then((result) => {
                if (result.value) {
                    _.axios({
                        method: "POST",
                        url,
                        data: formData,
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                        .then(resp => {
                            if (resp.status) {
                                _.$toast.success('Data Berhasil Disimpan')
                                _.$router.push('/smartlog')
                            } else {
                                console.log("Failed")
                                _.$toast.warning('Data Gagal Disimpan, Error: ' + resp.status)
                            }
                            _.saving = false
                        }).catch(err => {
                            _.saving = false
                            _.errors = err.response.data.errors
                            console.log("error validation", _.errors)
                            this.$refs.observer.setErrors(err.response.data.errors);
                            _.$toast.error(`Gagal! ${err.response.status} | ${err.response.statusText}`)
                        })
                } else {
                    _.saving = false
                }
            })

        },
        cancel() {
            this.$swal.fire({
                text: "Apakah Anda yakin, ingin membatalkan input data material?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#44A8BD',
                cancelButtonColor: '#D95E6A',
                confirmButtonText: 'Ya',
                cancelButtonText: 'Tidak'
            }).then((result) => {
                if (result.value) {
                    this.$router.push('/smartlog')
                }
            })
        }
    },
    watch: {
        deafult_kontrak: function (newVal) {
            if (newVal == 'select' && this.contracts.length == 0) {
                this.getKontrak()
            }
        },
        selectedSubCategories: function (newVal) {
            this.form.sub_category_id = newVal.id
        },
        selectedUnits: function (newVal) {
            this.form.unit_id = newVal.id
        },
        selectedWarehouses(newVal) {
            if (!newVal) {
                this.form.warehouse_id = null
                this.form.new_warehouse_name = ""
                return
            }

            if (newVal.isOther || newVal.isNewTag) {
                window.$('#modalOtherInput')
                    .off('shown.bs.modal') // supaya nggak double listener
                    .on('shown.bs.modal', () => {
                        this.$refs.otherInput.focus()
                    })
                    .modal('show')
                this.form.warehouse_id = null
            } else {
                window.$('#modalOtherInput').modal('hide')
                this.form.warehouse_id = newVal.id
                this.form.new_warehouse_name = ""
            }
        },
        selectedKontak(newVal) {
            if (!newVal) {
                this.form.contact_person_id = null
                this.form.new_contact_person_name = ""
                this.form.new_contact_person_phone_number = ""
                return
            }

            if (newVal.isOther || newVal.isNewTag) {
                window.$('#modalOtherContactInput')
                    .off('shown.bs.modal')
                    .on('shown.bs.modal', () => {
                        this.$refs.otherInputContact.focus()
                    })
                    .modal('show')
                this.form.contact_person_id = null
            } else {
                window.$('#modalOtherContactInput').modal('hide')
                this.form.contact_person_id = newVal.id
                this.form.new_contact_person_name = ""
                this.form.new_contact_person_phone_number = ""
            }
        },
        selectedProject: function (newVal) {
            this.form.contract_id = newVal.id
        }
    }
}
</script>

<style scoped>
/* custom radio input */
.custom-radio-group {
    display: flex;
    gap: 2rem;
    align-items: center;
}

.custom-radio {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    font-weight: 500;
}

.custom-radio input[type="radio"] {
    opacity: 0;
    position: absolute;
}

.radio-circle {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 2px solid #1592b4;
    border-radius: 50%;
    margin-right: 8px;
    position: relative;
    box-sizing: border-box;
}

.custom-radio input[type="radio"]:checked+.radio-circle::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    background-color: #1592b4;
    border-radius: 50%;
    transform: translate(-50%, -50%);
}

/* custom foto upload */
.foto-container {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.upload-box {
    width: 100px;
    height: 100px;
    border: 2px dashed #00a1b1;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 5px;
}

.upload-box i {
    font-size: 24px;
    color: #00a1b1;
}

.preview-box {
    /* width: 100px;
    height: 100px;
    position: relative;
    border-radius: 5px; */
    /* overflow: hidden; */
    width: 100px;
    height: auto;
    min-height: 100px;
    position: relative;
    border-radius: 5px;
}

.error-text {
    position: absolute;
    /* bottom: -30px; */
    top: 0;
    left: 0;
    bottom: 0;
    padding: 2px;
    font-size: 10px;
    color: black;
    background-color: lightcoral;
    white-space: normal;
    width: 100px;
    font-weight: bold;
}

.preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.btn-remove {
    position: absolute;
    top: -6px;
    right: -6px;
    background: red;
    color: white;
    border: none;
    border-radius: 50%;
    font-weight: bold;
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.set-main {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    font-weight: bold;
    font-size: 12px;
    text-align: center;
    padding: 2px;
    cursor: pointer;
}

.border-dashed {
    border-style: dashed !important;
}
</style>